import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state.placementDocuments || initialState;

export const selectPlacementDocuments = createSelector([selectDomain], state => state);
